import { render, staticRenderFns } from "./PersonalizedConfiguration.vue?vue&type=template&id=1d21e5c8&scoped=true"
import script from "./PersonalizedConfiguration.vue?vue&type=script&lang=js"
export * from "./PersonalizedConfiguration.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&external"
import style1 from "./PersonalizedConfiguration.vue?vue&type=style&index=1&id=1d21e5c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d21e5c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d21e5c8')) {
      api.createRecord('1d21e5c8', component.options)
    } else {
      api.reload('1d21e5c8', component.options)
    }
    module.hot.accept("./PersonalizedConfiguration.vue?vue&type=template&id=1d21e5c8&scoped=true", function () {
      api.rerender('1d21e5c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financialManagement/withdrawalRulesConfiguration/PersonalizedConfiguration.vue"
export default component.exports